import { Cache } from "memory-cache";
import {
  Client,
  Get_characters_character_id_location_ok,
  Get_characters_character_id_ship_ok,
} from "../service/esiclient";
import { CharacterEntity } from ".";
import { HandleEsiError } from "../helpers/ErrorDisplayHelper";

// ESI client
const esiClient = new Client();

// Cache
const cache = new Cache();

export async function getCachedCharacterEntity(character_id: number): Promise<CharacterEntity | null> {
  let entity: any = await cache.get(character_id.toString());
  if (entity) {
    return entity;
  }
  try {
    const character = await esiClient.get_characters_character_id(character_id, null, null);
    if (character !== null) {
      entity = new CharacterEntity(character_id, character);
      cache.put(character_id.toString(), entity, 60 * 60 * 1000 /* 1 hour */);
      return entity;
    } else {
      return null;
    }
  } catch (error) {
    HandleEsiError(error, character_id, "character");
    return null;
  }
}

export async function getCachedCharacterLocation(
  character_id: number,
  token: string
): Promise<Get_characters_character_id_location_ok | null> {
  let entity: any = await cache.get(character_id.toString() + "-location");
  if (entity) {
    return entity;
  }
  try {
    const characterLocation = await esiClient.get_characters_character_id_location(character_id, null, null, token);
    if (characterLocation !== null) {
      cache.put(character_id.toString() + "-location", characterLocation, 1 * 60 * 1000 /* 1 minute */);
      return characterLocation;
    } else {
      return null;
    }
  } catch (error) {
    HandleEsiError(error, character_id, "character_location");
    return null;
  }
}

export async function getCachedCharacterShip(
  character_id: number,
  token: string
): Promise<Get_characters_character_id_ship_ok | null> {
  let entity: any = await cache.get(character_id.toString() + "-ship");
  if (entity) {
    return entity;
  }
  try {
    const characterShip = await esiClient.get_characters_character_id_ship(character_id, null, null, token);
    if (characterShip !== null) {
      cache.put(character_id.toString() + "-ship", characterShip, 1 * 60 * 1000 /* 1 minute */);
      return characterShip;
    } else {
      return null;
    }
  } catch (error) {
    HandleEsiError(error, character_id, "character_ship");
    return null;
  }
}
